import {NgModule, Sanitizer} from '@angular/core';
import {SharedModule} from '@shared/shared.module';
import {RouterModule} from '@angular/router';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {TaxFormsRoutes} from './tax-forms.routes';
import { TaxFormsActionsCellViewerComponent } from './components/cell-viewers/tax-forms-actions-cell-viewer/tax-forms-actions-cell-viewer.component';
import {TaxFormsDynamicComponentHelper} from './tax-forms-dynamic-component-helper';
import {TaxFormsEffect} from './store/effects/tax-forms.effects';
import {taxFormsReducer} from './store/reducers/tax-forms.reducers';
import { FormGridTranslationDialogComponent } from './components/dialogs/form-grid-translation-dialog/form-grid-translation-dialog.component';
import { FormGridCompareDialogComponent } from './components/dialogs/form-grid-compare-dialog/form-grid-compare-dialog.component';
import { FormToolbarTranslationDialogComponent } from './components/dialogs/form-toolbar-translation-dialog/form-toolbar-translation-dialog.component';
import {TaxFormsService} from './services/tax-forms.service';
import { TaxFormsNameCellViewerComponent } from './components/cell-viewers/tax-forms-name-cell-viewer/tax-forms-name-cell-viewer.component';
import { FormToolbarCountrylistDialogComponent } from './components/dialogs/form-toolbar-countrylist-dialog/form-toolbar-countrylist-dialog.component';
import {TranslationModule} from '../translation/translation.module';
import { TaxFormsIframeContentComponent } from './components/tax-forms-iframe-content/tax-forms-iframe-content.component';
import { CommandService } from '@core/services/command.service';
import { PlatformCommand } from '@shared/commands/command-base';
import { PlatformToolItrceFormsHandler } from './services/platform-tool-itrce-forms.handler';
import { RootDynamicComponentHelper } from '@shared/helpers/root-dynamic-component-helper';
import { DateRangeDialogComponentComponent } from './components/date-range-dialog-component/date-range-dialog-component.component';

@NgModule({
  declarations: [
    TaxFormsActionsCellViewerComponent,
    FormGridTranslationDialogComponent,
    FormGridCompareDialogComponent,
    FormToolbarTranslationDialogComponent,
    TaxFormsNameCellViewerComponent,
    FormToolbarCountrylistDialogComponent,
    TaxFormsIframeContentComponent,
    DateRangeDialogComponentComponent],
  imports: [
    SharedModule,
    TranslationModule,
    RouterModule.forChild(TaxFormsRoutes),
    StoreModule.forFeature('tax-forms', taxFormsReducer),
    EffectsModule.forFeature([TaxFormsEffect]),
  ],
  exports: [TaxFormsActionsCellViewerComponent,
    FormGridTranslationDialogComponent,
    FormGridCompareDialogComponent,
    FormToolbarTranslationDialogComponent,
    TaxFormsNameCellViewerComponent,
    FormToolbarCountrylistDialogComponent,
    TaxFormsIframeContentComponent,
    DateRangeDialogComponentComponent
  ],
  providers: [TaxFormsService],

})
export class TaxFormsModule {
  constructor(private commandService: CommandService, private platformToolItrceFormsHandler: PlatformToolItrceFormsHandler) {
    RootDynamicComponentHelper.register("PlatformToolItrceFormsHandler", platformToolItrceFormsHandler);
    TaxFormsDynamicComponentHelper.init();
    const itrceFormslinkCommand = new PlatformCommand("ItrceFormsLinkCommand", "TaxFormsApi");
    this.commandService.registrPlatformLinkCommand("/itrce-planner/forms", itrceFormslinkCommand);
  }
}
